import { useState, useCallback } from "react";
import { useDispatch,useSelector } from "react-redux";
import { deleteSubscriptionModal,selector as deleteSubscriptionAPI } from "./deleteSubscriptionModalSlice";
import { fetchDasSubscriptionsData } from "../../../pages/integrations/das/listDas/listDasSlice";
import useNotification from "../../notification/useNotification";
import { isSuccessResponse } from "../../../common/utils";
import { useSpinner } from "../../../customHooks";

export const useDeleteSubscriptionModal = (subscriptionId: string) => {
  const dispatch: any = useDispatch();
  const [showModel, setShowModel] = useState<boolean>(false);
  const deleteSubscriptionResponse = useSelector(deleteSubscriptionAPI);
  useSpinner(deleteSubscriptionResponse.status);

  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  const { showSuccessNotification, showWarningNotification } = useNotification();
  const handleDeleteButtonClick = useCallback(() => {
    dispatch(deleteSubscriptionModal({ subscriptionId })).then((response) => {
      if (isSuccessResponse(response.payload)) {
        dispatch(fetchDasSubscriptionsData());
        showSuccessNotification(response.payload.message);
      }
      else {
        showWarningNotification(response.payload.response.data.message);
      }
    });
    setShowModel(false);
  }, [subscriptionId]);

  return {
    handleDeleteButtonClick,
    showModel,
    handleShow,
    handleClose,
  };
};
